import * as React from "react";
import { Drawer } from "components/fragments";
import { config } from "utils";
import { NavIcon } from "@lunchboxinc/lunchbox-components-v2/dist/components";

// TODO: Move to header, decouple from drawer and separate drawers from header
const NavDrawer = ({
  cartCount,
  iconType,
  icon,
  symbol,
  text,
  children,
  ...props
}) => (
  <Drawer.ResponsiveDrawer
    {...props}
    ariaLabel="Shopping Cart"
    drawerProps={{
      destroyOnClose: true,
    }}
    trigger={
      <a href="#" data-cy="cart-icon">
        <NavIcon
          themeType={config.theme.header.nav_icon || "Type1"}
          iconType={iconType}
          restaurantName={config.restaurant}
          symbol={symbol}
          iconSrc={icon}
        >
          {text}
          {!!cartCount && (
            <span
              style={{
                fontSize: "0.75rem",
                marginLeft: "0.25rem",
              }}
            >
              ({cartCount < 10 ? cartCount : "10+"})
            </span>
          )}
        </NavIcon>
      </a>
    }
  >
    {children}
  </Drawer.ResponsiveDrawer>
);

export default NavDrawer;
